"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useModal = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var Modal_1 = require("./Modal");
var useModal = function () {
    var ref = (0, react_1.useRef)(null);
    var mount = (0, jsx_runtime_1.jsx)(Modal_1.ModalMount, { ref: ref });
    var openModal = function (content) {
        if (!ref.current) {
            if (content !== null) {
                console.warn("showModal called on null ModalMountRef");
            }
            return;
        }
        ref.current.showModal(content);
    };
    var closeModal = function () { return openModal(null); };
    return [mount, openModal, closeModal];
};
exports.useModal = useModal;
